export default __webpack_public_path__ + "static/media/logo.39e76f5e.png";